import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../../app.service";
@Component({
    templateUrl: "./admin-layout.component.html"
})

export class AdminLayoutComponent {

    constructor(public router: Router, public appService: AppService) { }
    public logoff(): void {
        localStorage.removeItem("ani-token");
        this.router.navigate(["/login"]);
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/layout/admin-layout/admin-layout.component.ts